import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { setSnackbarMessage } from '../snackbarMessage/snackbarSlice';
import { initialState } from './state';
import * as api from 'src/api/banner/banner';
import { HomeDisplayBanner } from 'src/admin-entity/interface/home-display/home-display-banner.interface';
import { getErrorMessage } from 'src/utils/utilService';
import { AppState } from 'src/store';

export const getBannerList = createAsyncThunk(
    `bannerSlice/getBannerList`,
    async (_, { getState, dispatch, rejectWithValue }) => {
        try {
            const { bannerSearchCondition } = (getState() as AppState).banner;
            const res = await api.getBannerList(bannerSearchCondition.page, bannerSearchCondition.take);
            return res.data;
        } catch (err) {
            dispatch(setSnackbarMessage('삭제에 실패했습니다.'));
            return rejectWithValue(err);
        }
    },
);

export const searchBannerList = createAsyncThunk(
    `bannerSlice/searchBannerList`,
    async (_, { getState, dispatch, rejectWithValue }) => {
        try {
            const { take, status, linkType, title, bannerType } = (getState() as AppState).banner.bannerSearchCondition;

            const res = await api.searchBannerList(take, status, linkType, title, bannerType);
            return res.data;
        } catch (err) {
            dispatch(setSnackbarMessage(getErrorMessage(err)));
            return rejectWithValue(err);
        }
    },
);

export const searchBannerListForModal = createAsyncThunk(
    `bannerSlice/searchBannerListForModal`,
    async (_, { getState, dispatch, rejectWithValue }) => {
        try {
            const { bannerSearchConditionForModal } = (getState() as AppState).banner;
            const { selectedHomeDisplayCategory } = (getState() as AppState).homeDisplay;
            const { take, status, linkType, title } = bannerSearchConditionForModal;

            const res = await api.searchBannerList(
                take,
                status,
                linkType,
                title,
                selectedHomeDisplayCategory.bannerType,
            );
            return res.data;
        } catch (err) {
            dispatch(setSnackbarMessage(getErrorMessage(err)));
            return rejectWithValue(err);
        }
    },
);

export const bannerSlice = createSlice({
    name: 'bannerSlice',
    initialState,
    reducers: {
        initBannerSlice: () => {
            return initialState;
        },
        initBannerListForModal: state => {
            state.bannerListForModal = initialState.bannerListForModal;
        },
        setBannerSearchConditionPage: (state, action: PayloadAction<number>) => {
            state.bannerSearchCondition.page = action.payload;
        },
        setBannerSearchConditionTake: (state, action: PayloadAction<number>) => {
            state.bannerSearchCondition.take = action.payload;
        },
        setBannerSearchConditionPageForModal: (state, action: PayloadAction<number>) => {
            state.bannerSearchConditionForModal.page = action.payload;
        },
        setBannerSearchConditionTakeForModal: (state, action: PayloadAction<number>) => {
            state.bannerSearchConditionForModal.take = action.payload;
        },
        updateSearchCondition: (
            state,
            action: PayloadAction<{
                id: string;
                value: string | HomeDisplayBanner['linkType'] | HomeDisplayBanner['status'];
            }>,
        ) => {
            console.log(action.payload.id);
            console.log(action.payload.value);
            state.bannerSearchCondition[action.payload.id] = action.payload.value;
        },
        updateSearchConditionForModal: (
            state,
            action: PayloadAction<{
                id: string;
                value: string | HomeDisplayBanner['linkType'] | HomeDisplayBanner['status'];
            }>,
        ) => {
            console.log(action.payload.id);
            console.log(action.payload.value);
            state.bannerSearchConditionForModal[action.payload.id] = action.payload.value;
        },
        addBanners: (state, action: PayloadAction<HomeDisplayBanner[]>) => {
            state.selectedBanners.push(...action.payload);
        },
        addBanner: (state, action: PayloadAction<HomeDisplayBanner>) => {
            state.selectedBanners.push(action.payload);
        },
        removeBanner: (state, action: PayloadAction<HomeDisplayBanner>) => {
            state.selectedBanners = state.selectedBanners.filter(item => item.id !== action.payload.id);
        },
    },
    extraReducers: builder => {
        builder.addCase(getBannerList.fulfilled, (state, { payload }) => {
            state.bannerList = payload;
        });
        builder.addCase(searchBannerList.fulfilled, (state, { payload }) => {
            state.bannerList = payload;
        });
        builder.addCase(searchBannerListForModal.fulfilled, (state, { payload }) => {
            state.bannerListForModal = payload;
        });
    },
});

export default bannerSlice.reducer;
export const {
    initBannerSlice,
    updateSearchCondition,
    setBannerSearchConditionPage,
    setBannerSearchConditionTake,
    setBannerSearchConditionPageForModal,
    setBannerSearchConditionTakeForModal,
    updateSearchConditionForModal,
    addBanners,
    addBanner,
    removeBanner,
    initBannerListForModal,
} = bannerSlice.actions;
